<template>
  <button
    type="button"
    :class="buttonClasses"
    :disabled="disabled"
    v-on="$listeners"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'RoundedButton',
  props: {
    type: {
      type: String,
      default: 'filter',
      validator: (value) => ['form', 'filter'].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClasses() {
      return {
        filterButton: this.type === 'filter',
        formButton: this.type === 'form',
        'filterButton-active': this.type === 'filter' && this.active,
        'formButton-active': this.type === 'form' && this.active,
      }
    },
  },
}
</script>

<style>
/* Filter Button style */
.filterButton{
  border-radius: 200px;
  padding-right: 16px;
  padding-left: 16px;
  height: 30px;
  size: 12px;
  font-weight: 590;
  border: 1px solid #B4B7BA;
  color: #4E5155;
  background-color: transparent;
}

.filterButton-active,
.filterButton:hover{
  color: #4E5155;
  background-color: #E8E8E8;
}
.dark-style .filterButton.filterButton-active,
.dark-style .filterButton:hover{
  color: #26282D;
  background-color: #C1C1C1;
}
.dark-style .filterButton{
  color: #B3B4B4;
}
/* Form Button style */
.formButton{
  border-radius: 100px;
  padding-right: 8px;
  padding-left: 8px;
  height: 30px;
  border: 1px solid #AEB3B8;
  color: #4E5155;
  background-color: transparent;
}
.dark-style .formButton{
  color: #B3B4B4;
}
.formButton:active,
.formButton:hover,
.formButton-active{
  color: white;
  background-color: #3E4144;
  border: 1px solid #52565B;
}
.dark-style .formButton.formButton:active,
.dark-style .formButton:hover,
.dark-style .formButton-active{
  color: #26282D;
  background-color: #C1C1C1;
  border: 1px solid #AEB3B8;
}

</style>


